import type { ReactNode } from "react";
import { useNavigate } from "react-router";
import { CONSUMER_NAV } from "@/design/navItems";
import { ThemeToggle } from "@/design/ThemeToggle";
import { useMe } from "~/auth/MeProvider";
import { AppNav } from "./AppNav";
import { NotificationBell } from "./Bell";

/**
 * The signed-in Consumer's chrome (R22 T12).
 *
 * A Consumer gets the app navigation rather than the marketing header, on every
 * screen they can reach, which since H28 includes the guest surfaces: search
 * and a clinic's profile are where a signed-in customer spends their time, and
 * handing them a "Sign up" button there would be absurd.
 */
export function ConsumerChrome() {
  const { signOut } = useMe();
  const navigate = useNavigate();

  return (
    <AppNav
      items={CONSUMER_NAV}
      homeHref="/search"
      trailing={<NotificationBell />}
    >
      <ThemeToggle />
      <button
        type="button"
        className="text-sm font-medium text-muted hover:text-ink"
        onClick={() => {
          void signOut().then(() => navigate("/", { replace: true }));
        }}
      >
        Log out
      </button>
    </AppNav>
  );
}

/**
 * The frame for a signed-in Consumer's screens: their navigation, then content.
 * No public footer, which is the same call the Next host made: a signed-in
 * customer is using the app rather than reading about it.
 */
export function ConsumerPage({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-screen grow flex-col bg-page text-body">
      <ConsumerChrome />
      {children}
    </main>
  );
}
